module.exports = __webpack_public_path__ + "static/media/activitylog.c71e0390.png";